module.exports = __webpack_public_path__ + "d2d4622394c0e88a8c69122a9af2c9b8.ttf";